import { Report } from "../../../Interfaces/TableInterfaces";
import useSearchParam from "../../../Hooks/useSearchParam";
import { IRolePairPositionSearchParam } from "../../../Interfaces/deltaHedgeAccounts";
import RolePairPositionSearchParamUI from "./RolePairPositionSearchParamUI";
import RolePairPositionTable from "../../../Tables/DeltaHedgeAccount/RolePairPosition/RolePairPositionTable";
import { useState, useMemo, useEffect, useRef } from "react";
import CheckBox from "../../../Components/Checkbox";
import FileDownloader from "../../../Components/FileDownloader";
import { getRolePairPositionExcel } from "../../../Requests/deltaHedgeAccounts";
import { ISelectedTableInfo } from "../../../Interfaces/optionDomain";
import Orderbook from "./Orderbook";
import { IFilterTableCols } from "src/Tables/TableTemplate/tableTemplate";
// Common Components
import { Button, Modal } from "src/Components";
// Local Components
import FilterSettingModal from "./FilterSettingModal";

interface IVisibleHeaders {
  all: boolean;
  mediator: boolean;
}

enum ModalMode {
  Closed,
  FilterSetting,
}

const RolePairPosition = () => {
  const {
    clientSearchParamChangeHandler,
    clientSearchParams,
    onSubmit,
    serverSearchParams,
  } = useSearchParam({
    initialSearchParam: {} as IRolePairPositionSearchParam,
  });
  const initialAccountSearchDone = useRef(false);
  useEffect(() => {
    if (initialAccountSearchDone.current || !Array.isArray(clientSearchParams.userIds)) return;
    initialAccountSearchDone.current = true;
    onSubmit();
  }, [clientSearchParams.userIds, onSubmit]);

  const [visibleHeaders, setVisibleHeaders] = useState({} as IVisibleHeaders);
  const [selectedTableInfo, setSelectedTableInfo] =
    useState<ISelectedTableInfo | null>(null);
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const getFilterCols = (): IFilterTableCols => {
    const result: IFilterTableCols = {
      show: true,
      tableName: "rolePairPositionTable",
      allowedPositions: [],
    };
    if (visibleHeaders.all) result.allowedPositions.push("DefaultHidden");
    if (visibleHeaders.mediator) result.allowedPositions.push("Mediator");
    return result;
  };

  const headerVisiblitychangeHandler = (name: string, value: any) => {
    setVisibleHeaders({ ...visibleHeaders, [name]: value } as IVisibleHeaders);
  };

  const getModalUI = useMemo(() => {
    switch (modalMode) {
      case ModalMode.FilterSetting:
        return (
          <FilterSettingModal
            onClose={() => setModalMode(ModalMode.Closed)}
            onApplied={() => setRefreshFlag((prev) => !prev)}
          />
        );

      default:
        return <></>;
    }
  }, [modalMode]);

  return (
    <div className="flex flex-row justify-start items-start gap-1 w-full">
      {modalMode !== ModalMode.Closed ? (
        <Modal
          UI={getModalUI}
          onClose={() => setModalMode(ModalMode.Closed)}
          modalBoxClassName="!min-w-min !min-h-min"
        />
      ) : (
        <></>
      )}
      <RolePairPositionSearchParamUI
        searchParam={clientSearchParams}
        searchParamChangeHandler={clientSearchParamChangeHandler}
        onSubmit={onSubmit}
      />
      <div className="flex flex-col justify-start items-start w-[calc(100%-330px)]">
        <Button
          onClick={() => setModalMode(ModalMode.FilterSetting)}
          text="تنظیمات فیلتر"
          variant="outlined"
          className="!w-auto shrink-0"
        />
        <Orderbook
          selectedTableInfo={selectedTableInfo}
          totalPricesBesideOrderbooks
        />
        <div
          className="flex flex-row flex-nowrap justify-start items-center gap-5 w-full mt-3"
          dir="rtl"
        >
          <div className="bg-sky-200 rounded py-1 px-2 shrink-0">
            <CheckBox
              checked={visibleHeaders.all}
              label="جزئیات"
              name="all"
              onChange={headerVisiblitychangeHandler}
            />
          </div>
          <div className="bg-red-200 rounded py-1 px-2 shrink-0">
            <CheckBox
              checked={visibleHeaders.mediator}
              label="محاسبات"
              name="mediator"
              onChange={headerVisiblitychangeHandler}
            />
          </div>
          <FileDownloader getFile={getRolePairPositionExcel} />
        </div>
        <RolePairPositionTable
          filterCols={getFilterCols()}
          searchParams={serverSearchParams}
          refreshFlag={refreshFlag}
          onRowClick={(row) => {
            setSelectedTableInfo({
              id: row.id,
              insIds: [
                {
                  insId: row.instrumentId1,
                  ratio: 1,
                  side: row.orderSide1Enum,
                },
                {
                  insId: row.instrumentId2,
                  ratio: row.hedgeFactor?.toString().replaceAll(",", "") as any,
                  side: row.orderSide2Enum,
                },
              ],
            });
          }}
          selectedTableRow={selectedTableInfo?.id ?? null}
        />
      </div>
    </div>
  );
};

export default RolePairPosition;
